import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { createRequestOption } from '../web/request-util';

import { SERVER_API_URL } from '@app/app.constants';

@Injectable({
  providedIn: 'root',
})
export class ParameterService {
  private readonly BASE_URL = SERVER_API_URL + 'parameter';

  constructor(private http: HttpClient) {}

  getFilters(queries: any): Observable<any> {
    const query = createRequestOption(queries);
    return this.http.get(`${this.BASE_URL}/filter`, {
      params: query,
      observe: 'response',
    });
  }
}
